

'use strict'

 

// 'errors' factory is used as a central place of all APP LEVEL error messages.

// we made a central place so errors can be reusable.

// NOTE: The errorCode numbers DO NOT represent the statusCode of the API,

// these errorCodes are just sequencially numbered for use within the application

// itself

angular.module('cvsApp').factory('errors', [function(){

    var errors = [

      {

        "errorCode": "100", // Catch All error

        "errorMessage": "We're sorry. We are unable to process your request. Please call the number on the back of your benefit ID card for assistance."

      },          

      {

        "errorCode": "0",

        "errorMessage": "Operation Timed Out, Please Try again later."

      },

      {

        "errorCode": "500",

        "errorMessage": "We are sorry. We are unable to process your request."

      },

      {

        "errorCode": "401",

        "errorMessage": "Operation Not Allowed. Please Try Again Later."

      },

      {

        "errorCode": "001",

        "errorMessage": "Mail service Rx numbers must be 9 digits. Please try entering the number again."

      },

      {

        "errorCode": "002",

        "errorMessage": "Please enter the plan member's date of birth."

      },

      {

        "errorCode": "003",

        "errorMessage": "Please enter a date using the format mm/dd/yyyy."

      },

      {

        "errorCode": "004",

        "errorMessage": "This prescription has expired. Please contact Customer Care at the telephone number appearing on your prescription card"

      },

      {

        "errorCode": "005",

        "errorMessage": "No records found. Please check that you entered the correct information"

      },

      {

        "errorCode": "006",

        "errorMessage": "At least one valid Rx is required to refill a prescription."

      },

      {

        "errorCode": "007",

        "errorMessage": "Please enter the 9-digit Rx number."

      },

      {

        "errorCode": "008",

        "errorMessage": "Date of birth cannot be in the future."

      },

      {

        "errorCode": "009",

        "errorMessage": "The date of birth and Rx# you entered do not match our records. Please check that you entered the correct information."

     },

      {

        "errorCode": "010",

        "errorMessage": "This prescription has already been added to your order. Please enter a different Rx number."

      },

      {

        "errorCode": "011",

        "errorMessage": "Sorry, your prescription has either expired or no longer allows for refills. Please contact your pharmacy."

      },

      {

        "errorCode": "012",

        "errorMessage": "The Rx # can't be found for this member. Please check that you entered the correct information."

      },

      {

        "errorCode": "013",

        "errorMessage": "Sorry, we're unable to process your request. We've experienced an error with the network connection. Please try again later."

      },

      {

        "errorCode": "014",

        "errorMessage": "The Rx number has already been added."

      },

      {

        "errorCode": "015",

        "errorMessage": "We're sorry, but your prescription benefit plan does not include the Easy Refill service."

      },

      {

        "errorCode": "016",

        "errorMessage": "We're sorry, this service is unavailable right now. Please try again later."

      },

      {

        "errorCode": "017",

        "errorMessage": "The changes made on the screen will be lost, do you wish to continue?"

      },

      {

        "errorCode": "018",

        "errorMessage": "We're sorry; we are unable to process your request."

      },

      {

        "errorCode": "019",

        "errorMessage": "Please enter a valid Zip Code. The Zip should be either 5 or 9 digits. 9 digit zip codes should be in the format of 12345-6789."

      },

      {

        "errorCode": "020",

        "errorMessage": "There are no refills remaining for the prescription. If you have questions about your order, please call us at the toll-free number on your benefit ID card."

      },

      {

        "errorCode": "021",

        "errorMessage": "Please contact Customer Care at the telephone number appearing on your prescription card"

      },

      {

        "errorCode": "022",

        "errorMessage": "An order for this prescription is in process. Please contact Customer Care at the telephone number appearing on your prescription card."

      },

      {

        "errorCode": "023",

        "errorMessage": "It is too soon to refill this prescription. You can order this prescription on"

      },

      {

        "errorCode": "024",

        "errorMessage": "We're sorry, but your prescription benefit plan does not include the Easy Refill service."

      },

      {

        "errorCode": "025",

        "errorMessage": "We're sorry, but we have temporarily disabled this functionality because of too many failed attempts. Please try again later or call the number on the back of your benefit ID card for assistance."

      },

      {

        "errorCode": "026",

        "errorMessage": "We�re sorry. You cannot refill more than 20 prescriptions in one order."

      },

 

      // review controller errors

      {

        "errorCode": "030",

        "errorMessage": "We cannot ship this order to a P.O. Box. Please enter a street address."

      },

      {

        "errorCode": "031",

        "errorMessage": "We cannot ship to a P.O. Box using this shipping method. Please enter a street address."

      },

      {

        "errorCode": "032",

        "errorMessage": "Please enter a valid Address."

      },

 

     

      // payment controller errors

      {

        "errorCode": "040",

        "errorMessage": "This credit card is already saved in the system. Please select it from your existing payment methods."

      },

      {

        "errorCode": "041",

        "errorMessage": "There is no payment method specified on account. Please enter payment information to complete the order or contact Customer Care at the telephone number appearing on your prescription card"

      },

      {

        "errorCode": "042",

        "errorMessage": "Credit card <cardnumbermostlyhidden> has expired. Please choose another payment method."

      },

      {

        "errorCode": "043",

        "errorMessage": "We're sorry, but we can't process your request. Please try again later."

      },

      {

        "errorCode": "044",

        "errorMessage": "Please select a valid expiration date."

      }

    ];

 

    errors.getErrorMessage = function(errorNumber){

      var message = "";

      angular.forEach(errors,function(value,key){

        if(errorNumber == value.errorCode)

          message= value.errorMessage;

      });

      return message;

    }

 

    return errors;

 

}]);
